import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import {
  SetPermitTypeDocumentTypeSettings,
  SetPermitTypeDocumentTypeSettingsVariables,
} from "./__generated__/SetPermitTypeDocumentTypeSettings";

const SET_PERMIT_TYPE_DOCUMENT_TYPE_SETTINGS = gql`
  mutation SetPermitTypeDocumentTypeSettings(
    $organizationId: String!
    $permitTypeId: String!
    $documentTypeId: String!
    $documentTypeSettingsInput: DocumentTypeSettingsInput
  ) {
    setPermitTypeDocumentTypeSettings(
      input: {
        organizationId: $organizationId
        permitTypeId: $permitTypeId
        documentTypeId: $documentTypeId
        documentTypeSettingsInput: $documentTypeSettingsInput
      }
    ) {
      permitTypeDocumentType {
        id
        documentType {
          id
          name
          key
          settings {
            declaration
            requirement {
              key
              name
            }
          }
          isArchived
        }
        settings {
          declaration
          requirement {
            key
            name
          }
        }
      }
    }
  }
`;

export function useSetPermitTypeDocumentTypeSettings() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    SetPermitTypeDocumentTypeSettings,
    SetPermitTypeDocumentTypeSettingsVariables
  >(SET_PERMIT_TYPE_DOCUMENT_TYPE_SETTINGS, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
